import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Clock, CheckCircle } from 'lucide-react';
export function FinalCTA() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const handleCheckoutClick = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'El Método Ingreso Invisible 2026',
        content_type: 'product',
        value: 497,
        currency: 'MXN'
      });
    }
  };
  return <section id="precio" className="py-24 px-4 relative overflow-hidden" data-id="element-32">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a1628] via-[#1a2744] to-[#0a1628]" data-id="element-33" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#d4a843] rounded-full mix-blend-overlay filter blur-[100px] opacity-10 animate-pulse" data-id="element-34" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-35">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center bg-[#0a1628]/80 backdrop-blur-xl border border-[#d4a843]/30 rounded-3xl p-8 md:p-16 shadow-2xl" data-id="element-36">
          <motion.div variants={itemVariants} className="mb-6" data-id="element-37">
            <span className="inline-block px-4 py-1 rounded-full bg-[#d4a843]/10 border border-[#d4a843]/30 text-[#d4a843] text-sm font-bold tracking-wider uppercase mb-4" data-id="element-38">
              Oferta Exclusiva
            </span>
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4 leading-tight" data-id="element-39">
              Obtén El Método <br data-id="element-40" />
              <span className="text-[#d4a843]" data-id="element-41">Ingreso Invisible 2026</span>
            </h2>
            <p className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-42">
              Acceso inmediato a la guía completa + todos los bonos exclusivos
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-8 relative inline-block" data-id="element-43">
            <div className="absolute -top-6 -right-8 rotate-12 bg-[#e8c66a] text-[#0a1628] text-xs font-bold px-3 py-1 rounded-full shadow-lg" data-id="element-44">
              -50% OFF
            </div>
            <div className="flex items-baseline justify-center gap-2" data-id="element-45">
              <span className="text-gray-500 text-2xl line-through decoration-[#d4a843]/50 decoration-2" data-id="element-46">
                $997
              </span>
              <span className="text-6xl md:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#d4a843] via-[#e8c66a] to-[#d4a843]" data-id="element-47">
                $497
              </span>
              <span className="text-gray-400 text-xl font-medium" data-id="element-48">MXN</span>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-8" data-id="element-49">
            <motion.a href="https://www.tuvidadigitalmejora.com/cart/51418505806145:1" target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} whileHover={{
            scale: 1.05,
            boxShadow: '0 0 30px rgba(212,168,67,0.4)'
          }} whileTap={{
            scale: 0.95
          }} className="w-full md:w-auto bg-gradient-to-r from-[#d4a843] to-[#e8c66a] text-[#0a1628] text-xl font-bold py-4 px-12 rounded-xl shadow-xl flex items-center justify-center gap-3 mx-auto group inline-flex" data-id="element-50">
              Obtener Acceso Ahora
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-51" />
            </motion.a>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-10 flex items-center justify-center gap-2 text-[#e8c66a] bg-[#e8c66a]/5 py-2 px-4 rounded-lg inline-flex border border-[#e8c66a]/20" data-id="element-52">
            <Clock className="w-5 h-5 animate-pulse" data-id="element-53" />
            <span className="font-semibold tracking-wide" data-id="element-54">
              Oferta válida por tiempo limitado
            </span>
          </motion.div>

          <motion.div variants={itemVariants} className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-gray-400 border-t border-[#d4a843]/10 pt-8 mt-8" data-id="element-55">
            <div className="flex items-center gap-2" data-id="element-56">
              <ShieldCheck className="w-4 h-4 text-[#d4a843]" data-id="element-57" />
              <span data-id="element-58">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-59">
              <CheckCircle className="w-4 h-4 text-[#d4a843]" data-id="element-60" />
              <span data-id="element-61">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-62">
              <ShieldCheck className="w-4 h-4 text-[#d4a843]" data-id="element-63" />
              <span data-id="element-64">Garantía de Satisfacción</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}